/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Section_VoiceInputs */



/**
* | output |
* | --- |
* | "Voice Channel Permissions" |
*
* @param {Leveling_Perm_Section_VoiceInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_section_voice = /** @type {((inputs?: Leveling_Perm_Section_VoiceInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Section_VoiceInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Права голосовых каналов")
	return /** @type {LocalizedString} */ ("Voice Channel Permissions")
});